import Greycroft from "../../../../../public/greycroft.svg";
import Alleycorp from "../../../../../public/alleycorp.svg";
import Sound from "../../../../../public/sound.svg";
import Thrive from "../../../../../public/thrive-capital.svg";

export const investors = [Greycroft, Alleycorp, Sound, Thrive];
